import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Logger } from '@app/@core';

const log = new Logger('ImagesViewerComponent');

interface Image {
  url: string;
  barcode: string;
  title: string;
  noImage?: boolean;
}
@Component({
  selector: 'app-images-viewer',
  templateUrl: './images-viewer.component.html',
  styleUrls: ['./images-viewer.component.scss'],
  standalone: false,
})
export class ImagesViewerComponent implements OnInit {
  images: Image[];
  dir: string;

  constructor(
    public dialogRef: MatDialogRef<ImagesViewerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { images: Image[] },
  ) {
    this.images = data.images;
  }

  ngOnInit(): void {
    this.dir = localStorage.getItem('html-dir');
  }

  close() {
    this.dialogRef.close();
  }
}
